const hexColorRegExp = new RegExp(/^#([0-9a-f]{3}){1,2}$/, 'i');

export const isValidHexColor = (color: string): boolean => hexColorRegExp.test(color);
